export default __webpack_public_path__ + "static/media/zoho.35907271.svg";